<template>
  <article class="changelog-entry-card">
    <img
      v-if="entry.heroImageUrl"
      :src="entry.heroImageUrl"
      :alt="entry.title"
      class="changelog-entry-card__hero">
    <div class="changelog-entry-card__meta">
      <time class="changelog-entry-card__date">{{ formattedDate }}</time>
      <!-- The panel mixes feeds; badge only the non-default one. -->
      <AppBadge
        v-if="entry.feed === 'mlap'"
        variant="purple"
        size="xs">
        MLAP
      </AppBadge>
    </div>
    <h3 class="changelog-entry-card__title">
      {{ entry.title }}
    </h3>
    <!-- contentHtml is sanitized server-side for saved entries (allow-listed
         tags/attrs, iframes restricted to trusted video hosts) — see
         Changelog::Entry. The admin form preview passes the editor's own HTML,
         which the server has not sanitized yet. -->
    <!-- eslint-disable-next-line vue/no-v-html -->
    <div class="documentation-prose changelog-entry-card__body" v-html="entry.contentHtml" />
    <ChangelogReactionBar :entry="entry" :interactive="interactive" />
  </article>
</template>

<script setup>
import { computed } from 'vue'
// Direct import — the ui barrel drags @maptiler (Worker) into every
// consumer's jsdom test run (EntryPreviewPanel renders this card).
import AppBadge from '@/components/ui/AppBadge.vue'
import ChangelogReactionBar from './ChangelogReactionBar.vue'

const props = defineProps({
  entry: { type: Object, required: true },
  interactive: { type: Boolean, default: true }
})

const formattedDate = computed(() => new Date(props.entry.publishedAt)
  .toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }))
</script>
